class ShopToggle extends HTMLElement {
  constructor() {
    super();

    this.buttons = [];
    this.items = [];
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('button[data-by]');
    this.items = this.querySelectorAll('[data-by-link]');

    if (!this.buttons.length || !this.items.length) return;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.switchBy(button.dataset.by);
      });
    });
  }

  switchBy(type) {
    // 1. Active button
    this.buttons.forEach((btn) => {
      btn.classList.toggle(
        'shop-toggle--active',
        btn.dataset.by === type
      );
    });

    // 2. List elements
    this.items.forEach((item) => {
      const isActive = item.dataset.byLink === type;

      item.classList.toggle('shop-toggle-link--active', isActive);
      item.hidden = !isActive;
    });
  }
}

customElements.define('shop-toggle', ShopToggle);
